import { OrderValueType } from '@/api/order/models/OrderValueType';
import { useTexts } from '@/hooks/useTexts';
import { TableColumn } from '@/types/tables';

import { useOrderValueTypeText } from '../../../hooks/useOrderValueTypeText';
import { RedemptionFundRow } from '../types/RedemptionFundRow';

export const useCreateRedemptionFundTableColumns = (
  valueType: OrderValueType,
): TableColumn<RedemptionFundRow>[] => {
  const texts = useTexts();

  const valueTypeText = useOrderValueTypeText(valueType);

  return [
    {
      name: texts.orders.form.table.fund,
      key: 'fund',
      renderType: 'jsx',
      dataType: 'other',
    },
    {
      name: undefined,
      key: 'sellAll',
      renderType: 'jsx',
      dataType: 'other',
    },
    {
      name: texts.orders.form.table.holdings,
      key: 'holdings',
      renderType: 'jsx',
      dataType: 'other',
    },
    {
      name: valueTypeText,
      key: 'amount',
      renderType: 'jsx',
      dataType: 'other',
    },
  ];
};
